import * as Yup from "yup";

export const AddGroupSchema = Yup.object({

    group: Yup.string().required("Enter Group Name"),
    status: Yup.string().required("Select Status"),
    employee: Yup.array().min(2, 'Check at Least Two Rows').of(Yup.object().shape({}), 'Check at Least Two Rows'),
});

export const AddVenueSchema = Yup.object({

    venue: Yup.string().required("Enter Venue Name"),
    status: Yup.string().required("Select Status"),
});

export const EditVenueSchema = Yup.object({

    venue: Yup.string().required("Enter Venue Name"),
    status: Yup.string().required("Select Status"),
});

export const AnnouncementSchema = Yup.object({

    title: Yup.string().required("Enter Title"),
    description: Yup.string().required("Enter Description"),
    department: Yup.array().required("Select Permission To").min(1, " Select Permission To"),
    status: Yup.string().required("Select Status"),
});

export const EditAnnouncementSchema = Yup.object({

    title: Yup.string().required("Enter Title"),
    description: Yup.string().required("Enter Description"),
    department: Yup.array().required("Select Permission To").min(1, " Select Permission To"),
    status: Yup.string().required("Select Status"),
});

export const PollSchema = Yup.object({

    title: Yup.string().required("Enter Title"),
    description: Yup.string().required("Enter Description"),
    opt1: Yup.string().required("Enter First Option"),
    opt2: Yup.string().required("Enter Second Option"),
    // opt3: Yup.string().required("Enter Third Option"),
    // opt4: Yup.string().required("Enter Fourth Option"),
    department: Yup.array().required("Select Permission To").min(1, " Select Permission To"),
    status: Yup.string().required("Select Status"),
    start_date: Yup.date().min(new Date().toISOString().split('T')[0], "Select Future date").required("Select Start Date"),
    end_date: Yup.date().min(
        Yup.ref('start_date'),
        "End Date Can't be Before Start Date"
    ).required("Select End Date")
});

export const EditPollSchema = Yup.object({

    title: Yup.string().required("Enter Title"),
    description: Yup.string().required("Enter Description"),
    opt1: Yup.string().required("Enter First Option"),
    opt2: Yup.string().required("Enter Second Option"),
    // opt3: Yup.string().required("Enter Third Option"),
    // opt4: Yup.string().required("Enter Fourth Option"),
    department: Yup.array().required("Select Permission To").min(1, " Select Permission To"),
    status: Yup.string().required("Select Status"),
    start_date: Yup.date().required("Select Start Date"),
    end_date: Yup.date().min(
        Yup.ref('start_date'),
        "End Date Can't be Before Start Date"
    ).required("Select End Date")
});

export const QuizMarksSchema = Yup.object({

    total: Yup.number().typeError("Enter Only Number").required("Enter Total Marks").positive("Enter Only Number").integer("Enter Only Number"),
    passing: Yup.number().typeError("Enter Only Number").max(
        Yup.ref('total'),
        "Marks Should not Greater than Total Marks"
    ).required("Enter Passing Marks").positive("Enter Only Number").integer("Enter Only Number"),
});